import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/constants';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';

var GetPortfolioProfilesAction = function () {

}


GetPortfolioProfilesAction.prototype = {

	getPortfolioProfiles: function (portfolioId, fromPage, size) {

		restClient.getPortfolioProfiles(portfolioId, function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				} else{
					AppDispatcher.dispatch({
						actionType: Constant.GET_PORTFOLIO_PROFILES,
						data: error
					});
				}
			} else {
				//response['status']= 200;
				AppDispatcher.dispatch({
					actionType: Constant.GET_PORTFOLIO_PROFILES,
					data: response
				});
			}
		})
	}
}

export default new GetPortfolioProfilesAction();